import PropTypes from 'prop-types'
import { cn, containsSpecialChar } from '@/lib/utils'
import CheckRounded from '@/assets/icons/check-rounded'
import { useEffect } from 'react'

function PasswordChecks({ formik }) {
  const passwordChecks = {
    lengthCheck: formik.values.password.length >= 8,
    specialCharCheck: containsSpecialChar(formik.values.password),
    isValid: formik.values.password.length >= 8 && containsSpecialChar(formik.values.password),
  }

  useEffect(() => {
    formik.setStatus(passwordChecks.isValid)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [passwordChecks.isValid])

  return (
    <div className="flex flex-col items-start self-stretch gap-3">
      <div className="flex flex-row items-start self-stretch gap-2">
        <div
          data-testid="password-length-check"
          className={cn(
            'flex items-center justify-center w-6 h-6 rounded-full',
            passwordChecks.lengthCheck ? 'bg-[--brand-500]' : 'bg-[--neutral-100]'
          )}
        >
          <CheckRounded />
        </div>
        <p
          className={cn(
            'text-sm font-normal',
            formik.values.password.length === 0 || passwordChecks.lengthCheck
              ? 'text-neutral-700'
              : 'text-[--error-500]'
          )}
        >
          Must be at least 8 characters
        </p>
      </div>
      <div className="flex flex-row items-start self-stretch gap-2">
        <div
          data-testid="password-special-characters-check"
          className={cn(
            'flex items-center justify-center w-6 h-6 rounded-full',
            passwordChecks.specialCharCheck ? 'bg-[--brand-500]' : 'bg-[--neutral-100]'
          )}
        >
          <CheckRounded />
        </div>
        <p
          className={cn(
            'text-sm font-normal',
            formik.values.password.length === 0 || passwordChecks.specialCharCheck
              ? 'text-neutral-700'
              : 'text-[--error-500]'
          )}
        >
          Must contain one special character
        </p>
      </div>
    </div>
  )
}

PasswordChecks.propTypes = {
  formik: PropTypes.object.isRequired,
}

export default PasswordChecks
